module.exports = __webpack_public_path__ + "static/media/TowerRuin-Selected.55905e33.svg";